import React from 'react';

interface CoverageBarProps {
  value: number; // 0-100
  showLabel?: boolean;
  height?: number;
}

const getColor = (v: number) => {
  if (v >= 70) return 'bg-green-500';
  if (v >= 30) return 'bg-amber-500';
  return 'bg-red-500';
};

export function CoverageBar({ value, showLabel = true, height = 4 }: CoverageBarProps) {
  const pct = Math.min(100, Math.max(0, value));
  return (
    <div className="flex items-center gap-2">
      {showLabel && <span className="text-xs text-muted-foreground w-8 text-right">{Math.round(pct)}%</span>}
      <div className="flex-1 rounded-full bg-muted overflow-hidden" style={{ height }}>
        <div
          className={`h-full rounded-full transition-all ${getColor(pct)}`}
          style={{ width: `${pct}%` }}
          role="progressbar"
          aria-valuenow={pct}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label={`Coverage: ${Math.round(pct)}%`}
        />
      </div>
    </div>
  );
}
